/*
  fav-track.js — Favoritten.dk

  Faelles indgang til Plausible-haendelser, plus den ene haendelse der
  daekker ALLE veje til kurven.

  DESIGN: "Laeg i kurv" maales ved at aflytte fetch mod /cart/add, ikke ved
  at saette en handler paa hver knap. Der er mindst fire veje til kurven
  (kort-quick-add, produktside, drawer-opdatering, "Koeb nu"), og de
  gen-renderes loebende via Shopifys section rendering API. Knap-handlere
  ville falde af ved foerste opdatering; fetch-laget goer det ikke.

  Maaling maa aldrig braekke butikken: alt er pakket i try/catch, og
  favTrack() er en tom handling hvis Plausible ikke er indlaest (fx hvis
  scriptet blokeres af en annonceblokker).
*/
(function () {
  'use strict';

  function favTrack(navn, props) {
    try {
      if (typeof window.plausible !== 'function') return;
      window.plausible(navn, props ? { props: props } : undefined);
    } catch (e) { /* tavs */ }
  }
  window.favTrack = favTrack;

  /* ── Laeg i kurv ──
     Vi laeser svaret, ikke anmodningen: Shopify svarer 422 hvis varen ikke
     kan laegges i kurven (udsolgt, for stort antal), og de forsoeg skal
     ikke taelle som en kurvhandling. */
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = '';
      try { url = (typeof input === 'string' ? input : (input && input.url)) || ''; } catch (e) {}
      var erKurvTilfoej = url.indexOf('/cart/add') !== -1;

      var svar = origFetch.apply(this, arguments);
      if (!erKurvTilfoej) return svar;

      return svar.then(function (res) {
        try {
          if (res && res.ok) {
            /* klon, saa temaets egen laesning af svaret ikke forstyrres */
            res.clone().json().then(function (data) {
              var vare = (data && data.items && data.items[0]) || data || {};
              favTrack('Laeg i kurv', {
                vare: String(vare.product_title || vare.title || 'ukendt').slice(0, 90),
                pris: vare.price != null ? String(Math.round(vare.price / 100)) : 'ukendt',
              });
            }).catch(function () {});
          }
        } catch (e) { /* tavs */ }
        return res;
      });
    };
  }
})();
